import React from 'react';

import Badge, { type BadgeProps } from 'common/uiV3/Badge';

import type { IdeaStatus } from 'common/api/resources/statuses';
import type { ColorValues } from 'common/colors/constants';

type Props = BadgeProps & {
  status: IdeaStatus;
};

const IdeaStatusPill = ({ status, ...props }: Props) => {
  return (
    <Badge
      style={{
        color: status.color as ColorValues,
        background: `${status.color}20` as ColorValues,
        textTransform: 'capitalize',
      }}
      {...props}>
      <div className="truncate">{status.name}</div>
    </Badge>
  );
};

export default IdeaStatusPill;
